export function getBirthDateFromIIN(iin: string): Date | null {
  if (!/^\d{12}$/.test(iin)) {
    return null;
  }

  const yearPart = parseInt(iin.slice(0, 2), 10);
  const month = parseInt(iin.slice(2, 4), 10);
  const day = parseInt(iin.slice(4, 6), 10);
  const centuryCode = parseInt(iin[6], 10);

  let fullYear: number;

  if (centuryCode === 1 || centuryCode === 2) {
    fullYear = 1800 + yearPart;
  } else if (centuryCode === 3 || centuryCode === 4) {
    fullYear = 1900 + yearPart;
  } else if (centuryCode === 5 || centuryCode === 6) {
    fullYear = 2000 + yearPart;
  } else {
    return null;
  }

  // Проверка корректности даты
  const date = new Date(fullYear, month - 1, day);

  if (
    date.getFullYear() !== fullYear ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
}
